import React from "react";
import { graphql } from "gatsby";
import { classNames } from "utils";

import getIcon from "components/Icons";

import * as styles from "./SectionPricingFeatureTable.module.less";

const GreenCheckmark = () => getIcon("greenCheck");

/**
 * We use this to define what will be queried for this component
 * This also serves as typings (See `Gatsby.SectionPricingFeatureTableDataFragment` below)
 */
export const SectionPricingFeatureTableDataFragment = graphql`
  fragment SectionPricingFeatureTableData on MarkdownRemarkFrontmatterSections {
    tables {
      title
      firstColumnTitle
      secondColumnTitle
      thirdColumnTitle
      rows {
        title
        firstColumnChecked
        secondColumnChecked
        thirdColumnChecked
      }
    }
    section_id
  }
`;

/**
 * @param {GatsbyTypes.SectionPricingFeatureTableDataFragment} props
 */
export default function SectionPricingFeatureTable({
  tables = [],
  section_id,
}) {
  return (
    <section id={section_id} className={styles.pricingFeatureTableSection}>
      <div className={styles.container}>
        {tables.map(
          (
            {
              title,
              rows,
              firstColumnTitle,
              secondColumnTitle,
              thirdColumnTitle,
            },
            ind
          ) => {
            return (
              <div className={styles.table} key={`table-${ind}`}>
                <div className={classNames(styles.title, styles.firstField)}>
                  {title}
                </div>
                <div className={styles.columnTitle}>{firstColumnTitle}</div>
                <div className={styles.columnTitle}>{secondColumnTitle}</div>
                <div
                  className={classNames(styles.columnTitle, styles.lastField)}
                >
                  {thirdColumnTitle}
                </div>
                {rows.map(
                  (
                    {
                      title: rowTitle,
                      firstColumnChecked,
                      secondColumnChecked,
                      thirdColumnChecked,
                    },
                    rowInd
                  ) => {
                    return (
                      <React.Fragment key={`row-${rowInd}`}>
                        <div
                          className={classNames(
                            styles.featureTitle,
                            styles.firstField
                          )}
                        >
                          <div className={styles.listItem}>{rowTitle}</div>
                        </div>
                        <div
                          className={classNames(
                            styles.column,
                            styles.checkField
                          )}
                        >
                          {firstColumnChecked ? <GreenCheckmark /> : null}
                        </div>
                        <div
                          className={classNames(
                            styles.column,
                            styles.checkField
                          )}
                        >
                          {secondColumnChecked ? <GreenCheckmark /> : null}
                        </div>
                        <div
                          className={classNames(
                            styles.column,
                            styles.checkField,
                            styles.lastField
                          )}
                        >
                          {thirdColumnChecked ? <GreenCheckmark /> : null}
                        </div>
                        {rowInd !== rows.length - 1 ? (
                          <>
                            <div className={styles.line} />
                            <div className={styles.line} />
                            <div className={styles.line} />
                            <div className={styles.line} />
                          </>
                        ) : null}
                      </React.Fragment>
                    );
                  }
                )}
              </div>
            );
          }
        )}
      </div>
    </section>
  );
}
